import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const { login, refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const sessionId = searchParams.get('session_id');

    if (token) {
      // Google OAuth callback — fetch user info then redirect
      fetch(`${config.apiBaseURL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(r => r.json())
        .then(user => {
          login(token, user);
          navigate(user.subscription_status === 'active' ? '/' : '/subscribe');
        })
        .catch(() => navigate('/login?error=callback'));
      return;
    }

    if (sessionId) {
      // Stripe checkout success — refresh subscription status
      refreshUser().then(() => navigate('/'));
      return;
    }

    navigate('/');
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
